import { NoteRequest, NoteFormValues } from '../../../interfaces/note';

export const getNoteRequest = (formValues: NoteFormValues): NoteRequest => {
  return {
    note: formValues.note,
    users: formValues.users.map((user) => ({ id: user.id })),
  };
};
